module.exports = __webpack_public_path__ + "img/02.37ced013.jpg";